import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import {
    DynamicDialogConfig,
    DynamicDialogRef
} from '../../shared/efaact-primeng.module';
import { LoggingService } from '../../shared/services/logging';

@Component({
    selector: 'ef-pin-dialog',
    templateUrl: './pin-dialog.component.html',
    styleUrls: ['./pin-dialog.component.scss'],
    standalone: false
})
export class PinDialogComponent implements OnInit {
    @Output() Save = new EventEmitter<any>();
    @Output() Cancel = new EventEmitter();
    pinFormGroup: UntypedFormGroup;
    constructor(
        public dialogRef: DynamicDialogRef,
        public config: DynamicDialogConfig,
        private log: LoggingService
    ) {
        this.pinFormGroup = new UntypedFormGroup({
            pin: new UntypedFormControl(config.data.pin)
        });
    }

    ngOnInit(): void {}

    onSave(form): void {
        this.log.verbose({
            type: 'PinDialogComponent:onSave',
            form
        });
        this.dialogRef.close(form);
    }
    onCancel(): void {
        this.dialogRef.close();
    }
}
